import { createAction } from 'redux-actions';
import { initialState, SubsidiesState } from './reducers';
import {
	CheckoutOrderFragment,
	OrderSubsidyInfoQueryResult,
	Subsidy,
	SubsidyTravellerParameters
} from '@websky/graphql';
import produce from 'immer';

export const setSubsidiesState = createAction<SubsidiesState, CheckoutOrderFragment>(
	'SUBSIDIES/SET_SUBSIDIES_STATE',
	(order: CheckoutOrderFragment) => {
		return produce({ ...initialState }, draft => {
			draft.selectSubsidiesError = null;

			for (const traveller of order.travellers) {
				draft.availableSubsidiesByPassengers[traveller.id] = [];
			}

			for (const traveller of order.travellers) {
				draft.selectedSubsidies[traveller.id] = [];

				if (!traveller.subsidyInfo) {
					draft.availableSubsidiesByPassengers[traveller.id] = [];
				}

				if (traveller.subsidyInfo) {
					for (const subsidy of traveller.subsidyInfo.subsidies) {
						draft.availableSubsidiesByPassengers[traveller.id].push({
							id: subsidy.id,
							type: subsidy.type,
							name: subsidy.name,
							description: subsidy.description,
							validation: subsidy.validation
						});
					}
				}
			}
		});
	}
);

export const setSubsidiesLoading = createAction<boolean>('SUBSIDIES/SET_LOADING');
export const setSubsidiesResultsOpen = createAction<boolean>('SUBSIDIES/SET_RESULTS_OPEN');

export const checkSubsidy = createAction<SubsidyTravellerParameters[]>('SUBSIDIES/CHECK_SUBSIDY');

export const setCheckSubsidyResult = createAction<OrderSubsidyInfoQueryResult['data']['OrderSubsidyInfo']>(
	'SUBSIDIES/SET_CHECK_SUBSIDY_RESULT'
);

export const clearSelectedSubsidies = createAction<void>('SUBSIDIES/CLEAR_SELECTED_SUBSIDIES');

export const selectSubsidy = createAction<{ subsidyId: string; passengerId: string; segmentId: string }>(
	'SUBSIDIES/SELECT_SUBSIDY'
);

export const setSubsidiesError = createAction<string>('SUBSIDIES/SET_ERROR');

export const selectSubsidies = createAction<{ passengerId: string; subisdies: Subsidy[] }>(
	'SUBSIDIES/SELECT_SUBSIDIES'
);

export const setCheckedTravellers = createAction<SubsidyTravellerParameters[]>('SUBSIDIES/SET_CHECKED_TRAVELLERS');
